import { render, staticRenderFns } from "./Arquivar.vue?vue&type=template&id=10617182"
import script from "./Arquivar.vue?vue&type=script&lang=js"
export * from "./Arquivar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports